import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar.js';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Team_adddocument(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



   //FILTER VARIABLES

   
  //Variables for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
     

  //filter_val
  const[filterval,setfilterval]=useState(0);
  const[errorvar,seterrorvar]=useState();

  
 //image upload
 //File Upload
 const [selectedFile, setSelectedFile] = React.useState(null);
 const handleFileChange = (event) => {  const file = event.target.files[0];  setSelectedFile(file); };
 const[attachment_link_er,setattachment_link_er]=useState();



  //Variables
const[data,setData] = useState([]);//SetData Variable

  const[upload_type,setupload_type]=useState();//const updateupload_type = (event) => { setupload_type(event.target.value);}; const[upload_type_er,setupload_type_er]=useState();
  const[document_id,setdocument_id]=useState();const updatedocument_id = (event) => { setdocument_id(event.target.value);}; const[document_id_er,setdocument_id_er]=useState();
  const[document_name,setdocument_name]=useState();const updatedocument_name = (event) => { setdocument_name(event.target.value);}; const[document_name_er,setdocument_name_er]=useState();
  const[project_name,setproject_name]=useState();const updateproject_name = (event) => { setproject_name(event.target.value);}; const[project_name_er,setproject_name_er]=useState();
  const[project_type,setproject_type]=useState();const updateproject_type = (event) => { setproject_type(event.target.value);}; const[project_type_er,setproject_type_er]=useState();
  const[document_type,setdocument_type]=useState();const updatedocument_type = (event) => { setdocument_type(event.target.value);}; const[document_type_er,setdocument_type_er]=useState();
  const[document_category,setdocument_category]=useState();const updatedocument_category = (event) => { setdocument_category(event.target.value);}; const[document_category_er,setdocument_category_er]=useState();
  const[document_remarks,setdocument_remarks]=useState();const updatedocument_remarks = (event) => { setdocument_remarks(event.target.value);}; const[document_remarks_er,setdocument_remarks_er]=useState();
  const[document_status,setdocument_status]=useState();const updatedocument_status = (event) => { setdocument_status(event.target.value);}; const[document_status_er,setdocument_status_er]=useState();
  const[user_id,setuser_id]=useState(sessionStorage.getItem("UserId00"));//const updateuser_id = (event) => { setuser_id(event.target.value);}; const[user_id_er,setuser_id_er]=useState();
  const[document_link,setdocument_link]=useState();const updatedocument_link = (event) => { setdocument_link(event.target.value);}; const[document_link_er,setdocument_link_er]=useState();


 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();


/***************** ADD TEAM MEMBER FUNCTION START  ******************/
function adddocument(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){


    //Setting Error Variables
    //setupload_type_er(" "); setuser_id_er(" ");
    setdocument_id_er(" ");setdocument_name_er(" ");setproject_name_er(" ");setproject_type_er(" ");
    setdocument_type_er(" "); setdocument_category_er(" "); setdocument_remarks_er(" "); setdocument_status_er(" ");
     seterror_msg(" ");
   
    
//Fetching Form Data
let noerror = 0;
//let $upload_type = document.getElementById("upload_type").value; if($upload_type==""){ setupload_type_er("Upload Type is required !");noerror = noerror+1; }//upload_type
let $document_id = document.getElementById("document_id").value; if($document_id==""){ setdocument_id_er("Document Id is required !");noerror = noerror+1; }//document_id
let $document_name = document.getElementById("document_name").value; if($document_name==""){ setdocument_name_er("Document Name is required !");noerror = noerror+1; }//document_name
let $project_name = document.getElementById("project_name").value; if($project_name==""){ setproject_name_er("Project Name is required !");noerror = noerror+1; }//project_name
let $project_type = document.getElementById("project_type").value; if($project_type==""){ setproject_type_er("Project Type is required !");noerror = noerror+1; }//project_type
let $document_type = document.getElementById("document_type").value; if($document_type==""){ setdocument_type_er("Document Type is required !");noerror = noerror+1; }//document_type
let $document_category = document.getElementById("document_category").value; if($document_category==""){ setdocument_category_er("Document Category is required !");noerror = noerror+1; }//document_category
let $document_remarks = document.getElementById("document_remarks").value; if($document_remarks==""){ setdocument_remarks_er("Document Remarks is required !");noerror = noerror+1; }//document_remarks
let $document_status = document.getElementById("document_status").value; if($document_status==""){ setdocument_status_er("Document Status is required !");noerror = noerror+1; }//document_remarks
//let $user_id = document.getElementById("user_id").value; if($user_id==""){ setuser_id_er("User Id is required !");noerror = noerror+1; }//user_id


//No primary errors
if(noerror==0){

  const addBtn = document.getElementById("submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional


    //disabling button
    document.getElementById('submit-btn').disabled = true; 


  //Sending Data through axios
  axios.post("add-new-document", { 
  Log_id:logid,
  Token:token,
  User_id:user_id,
  Upload_type:"team",
  Document_id:$document_id,
  Document_name:$document_name,
  Project_name:$project_name,
  Project_type:$project_type,
  Document_type:$document_type,
  Document_category:$document_category,
  Document_remarks:$document_remarks,
  Document_status:$document_status,
  User_id:user_id, //$user_id,
  Document_link:selectedFile,
  
  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {
    
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "Add Document";

      //enabling button
     // document.getElementById('submit-btn').disabled = false; 

  //Validation Errors
  if(response.data.validatorerror){
  setdocument_id_er(response.data.validatorerror.Document_id);
  setdocument_name_er(response.data.validatorerror.Document_name);
  setproject_name_er(response.data.validatorerror.Project_name);
  setproject_type_er(response.data.validatorerror.Project_type);
  setdocument_category_er(response.data.validatorerror.Document_category);
  setdocument_remarks_er(response.data.validatorerror.Document_remarks);
  setdocument_status_er(response.data.validatorerror.Document_status);
  setdocument_link_er(response.data.validatorerror.Document_link);
  //setuser_id_er(response.data.validatorerror.User_id);
  seterror_msg("Cannot Add Document !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

//  settraining_name_er(response.data.validatorerror.Training_name);
  setdocument_id_er(response.data.document_id_er);
  setdocument_name_er(response.data.document_name_er);
  setproject_name_er(response.data.project_name_er);
  setproject_type_er(response.data.project_type_er);
  setdocument_category_er(response.data.document_category_er);
  setdocument_remarks_er(response.data.document_remarks_er);
  setdocument_status_er(response.data.document_status_er);
  //setuser_id_er(response.data.user_id_er);
  seterror_msg("Cannot Add Document !");
  
  
  }
  
  //Invalid Errors
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ 
    
   //setupload_type_er(" "); setuser_id(" ");
    setdocument_id(" ");setdocument_name(" ");setproject_name(" ");setproject_type(" ");
    setdocument_type(" "); setdocument_category(" "); setdocument_remarks(" "); setdocument_status(" ");
     seterror_msg(" ");

    document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Add Team Member !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** CREATE TRAINING FUNCTION END  ******************/


 
return(
    <>
      <Helmet>
            <meta name="robots" content="noindex,nofollow" />
      </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

        {/* CREATE SUCCESS CARD START */}
       <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-primary">Document Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a><button class="mt-3 btn btn-outline-primary"  onClick={()=>{
                       // sessionStorage.removeItem("EditId");
                        document.getElementById("success-card").style.display="none";
                        
                      }}>Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
       </div>
      {/* CREATE SUCCESS CARD END */}

            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">TEAM PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">ADD NEW DOCUMENT</p>
                  </a>
                </div>

              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

          
            <div className="row">
              <div className="col-12 grid-margin">
          
            {/* CREATE LICENSE FORM START */}
            <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Add New Document</h4>
                    <div class="form-sample">
                      <p class="card-description">add document</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Document Id<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="document_id" placeholder="DOC0001" value={document_id} onChange={updatedocument_id} />
                              <code>{document_id_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Document Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="document_name"  placeholder="Document Name" value={document_name} onChange={updatedocument_name} />
                              <code>{document_name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Project Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="project_name" placeholder="Project Name" value={project_name} onChange={updateproject_name} />
                              <code>{project_name_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Project Type<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="project_type" class="form-control" id="project_type"  placeholder="Project Type" value={project_type} onChange={updateproject_type} />
                              <code>{project_type_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Document Type<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="document_type" value={document_type} placeholder="Document Type" onChange={updatedocument_type} />
                              <code>{document_type_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Document Category<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="document_category" value={document_category} placeholder="Document Category" onChange={updatedocument_category} />
                              <code>{document_category_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Document Status<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="document_status" value={document_status} placeholder="1" onChange={updatedocument_status} style={{padding:"1rem"}}>
                              <option value="public">public</option>
                              <option value="private">private</option>
                              </select>
                              <code>{document_status_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="form-group">
                        <label for="exampleTextarea1">Document Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="remarks" id="document_remarks" value={document_remarks} onChange={updatedocument_remarks} ></textarea>
                        <code>{document_remarks_er}</code>
                        </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Upload Document</label>
                            <div class="col-sm-3">
                              <input type="file" class="form-control"  id="logo_link" onChange={handleFileChange} multiple />
                              {selectedFile && <p>Selected file: {selectedFile.name}</p>}
                              <code>{document_link_er}</code>
                            </div>
                          <div class="col-sm-5">
                          <p>Allowed File format (.png, .jpg), Max. file Size Allowed 5mb. </p>
                          </div>
                        </div>
                      </div>
                        <div class="row">
                          <div class="col-md-6">
                            <button class="btn btn-lg btn-primary" style={{fontWeight:"bold"}} onClick={adddocument} id="submit-btn">Add Document</button>
                         </div>
                        </div>
                      
                    </div>
                  </div>
                </div>
            {/* CREATE LICENSE FORM END */}

              </div>
          </div>

            


          {/*}  <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>
          */}
           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Team_adddocument;